export function isFieldsetFormat(answerFormat) {
    return !!answerFormat && (
        answerFormat.type === "TextChoiceAnswerFormat" ||
        answerFormat.type === "BooleanAnswerFormat" ||
        answerFormat.type === "HeightAnswerFormat"
    );
}
